// https://github.com/lumapps/core/blob/master/specs/bookmark_api_v1.yaml

import {
    createUserBookmark,
    GetUserBookmarkParams,
    listUserBookmarks,
    ListUserBookmarksParams,
    getUserBookmark,
    deleteBookmarkItem,
    CreateUserBookmarkParams,
    DeleteUserBookmarkItemParams,
} from '@lumapps/user-bookmarks/api';
import { userProfileApi } from '@lumapps/user-profile/api';

import { USER_SAVED_ITEM_SCOPE } from '../constants';

const listSavedItems = (params: ListUserBookmarksParams) => listUserBookmarks('saved-items', params);
const getSavedItem = (params: GetUserBookmarkParams) => getUserBookmark('saved-items', params);
const createSavedItem = (params: CreateUserBookmarkParams) => createUserBookmark('saved-items', params);
const deleteSavedItem = (params: DeleteUserBookmarkItemParams) => deleteBookmarkItem('saved-items', params);

/** Params that identify a single saved-item status query (excludes `priority`, a transport concern). */
export type SavedItemQueryKeyParams = Pick<
    GetUserBookmarkParams,
    'resourceId' | 'resourceType' | 'userId' | 'acceptLanguageHeader'
>;

/** React Query keys for the saved-item feature. */
export const savedItemQueryKeys = {
    all: [USER_SAVED_ITEM_SCOPE] as const,
    // Pick identity fields explicitly so extra params (e.g. `priority`) can't leak into the key.
    detail: ({ userId, resourceId, resourceType, acceptLanguageHeader }: SavedItemQueryKeyParams) =>
        [...savedItemQueryKeys.all, { userId, resourceId, resourceType, acceptLanguageHeader }] as const,
};

export { userProfileApi as savedItemsApi, listSavedItems, getSavedItem, createSavedItem, deleteSavedItem };
